import { Row } from '@tanstack/react-table';
import { useContextMenu } from 'app/components/ChakraTableList';
import { StickyTable } from 'app/components/Core/StickyTable/StickyTable';
import { AudioPlayerAudioInstance } from 'app/store/AudioPlayer/slice.types';
import { useCallback, useMemo, useRef } from 'react';
import { useTotalWidth } from 'app/components/Core/StickyTable';
import { AudioPlayerPlaylistTableRow } from './AudioPlayerPlaylistTableRow';
import { getColumns } from './utils';

interface AudioPlayerPlaylistTableProps {
  queue: AudioPlayerAudioInstance[];
  setViewedNoteAudio: (
    value: React.SetStateAction<AudioPlayerAudioInstance | null>
  ) => void;
}

export const AudioPlayerPlaylistTable = ({
  queue,
  setViewedNoteAudio,
}: AudioPlayerPlaylistTableProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const tableKey = 'player-playlist';
  const contextMenuProps = useContextMenu();
  const totalWidth = useTotalWidth(ref);
  const columns = useMemo(() => getColumns(totalWidth), [totalWidth]);

  const rowRenderer = useCallback(
    (item: Row<AudioPlayerAudioInstance>, index) => {
      const playlistAudio = item.original;

      return (
        <AudioPlayerPlaylistTableRow
          key={playlistAudio.playlistAudioGuid}
          index={index}
          audio={playlistAudio}
          setViewedNoteAudio={setViewedNoteAudio}
        />
      );
    },
    [setViewedNoteAudio]
  );

  return (
    <>
      <StickyTable<AudioPlayerAudioInstance>
        data-testid="player-playlist"
        tableKey={tableKey}
        ref={ref}
        data={queue}
        columns={columns}
        rowRenderer={rowRenderer}
        contextMenuProps={contextMenuProps}
      />
    </>
  );
};
